import React from "react";

type ToggleProps = {
  on: boolean;
  onChange: (next: boolean) => void;
  label?: React.ReactNode;
};

export function Toggle({ on, onChange, label }: ToggleProps) {
  return (
    <label className="toggle-row" onClick={() => onChange(!on)}>
      <button type="button" className={`toggle ${on ? "on" : ""}`} aria-pressed={on} />
      {label && <span>{label}</span>}
    </label>
  );
}
